import React from "react";
import lighthouse from "../../assets/images/lighthouse.jpg";
import { Link, useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  function gotoLearnPager() {
    navigate("/pytopics");
  }

  return (
    <section className="text-gray-600 body-font">
      <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
            <h1 className="font-bold">Welcome</h1>
            <br className="hidden lg:inline-block" />
            <h3>Let's Begin the Ultimate Coding Journey Here!</h3>
          </h1>
          <p className="mb-8 leading-relaxed text-justify">
            Are you ready to dive into the world of coding and turn your ideas
            into reality?
            <br />
            The best way to learn and master programming is through
            collaboration and community. This platform can help you connect you
            with fellow learners, mentors, and industry experts to create a
            dynamic and supportive learning environment. <br /> With experienced
            developers, a vibrant community, and flexible online sessions,
            you'll gain the knowledge and confidence needed to succeed in the
            ever-evolving world of technology. <br />
            Let's join this amazing journey to explore, learn, and innovate.
            Start coding your future with <b> Sachin Shelke</b> today!
          </p>
          <div className="flex justify-center">
            <button
              onClick={gotoLearnPager}
              className="inline-flex text-white bg-blue-600 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg"
            >
              {/* <Link to="/pytopics" className=" text-white"> */}
              Lets Start!!
              {/* </Link> */}
            </button>
            {/* <button className="ml-4 inline-flex text-gray-700 bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-gray-200 rounded text-lg">
              Button
            </button> */}
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-cover object-center rounded"
            alt="hero"
            // src="https://dummyimage.com/720x600"
            // src="https://picsum.photos/720/600"
            src={lighthouse}
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
